module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Brushstrokes")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#on-love"
    }
  }, [_vm._v("On Love")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0002#a-midsummer-nights-dream"
    }
  }, [_vm._v("A Midsummer Night’s Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0004#artefacts"
    }
  }, [_vm._v("Artefacts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0006#july"
    }
  }, [_vm._v("July")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0007#by-the-seaside"
    }
  }, [_vm._v("By the Seaside")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#bandits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bandits")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#ce-matin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ce Matin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#r%C3%AAver",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rêver")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0012#sous-la-peau",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sous la Peau")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0014#questions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0016#hors-du-temps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hors du Temps")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0017#les-cerisiers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Les Cerisiers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#wisteria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisteria")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0021#windows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windows")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#d%C3%A9couvertes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Découvertes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#recipe-for-a-beautiful-memory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipe for a Beautiful Memory")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0025#summertime",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summertime")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0026#you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0029#composition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Composition")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0030#two-roads",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Roads")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0034#home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0037#starry-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starry Night")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0038#goodbyes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goodbyes")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#on-fear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Fear")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0041#in-veritas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Veritas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0043#caught",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caught")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0045#unveil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Un)Veil")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0047#pandora",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pandora")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0050#tensionrelease",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tension/Release")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0053#under-the-microscope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under the Microscope")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0055#thunder",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thunder")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#on-frustration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Frustration")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0057#beneath-the-surface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beneath the Surface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0062#waxingwaning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waxing/Waning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0064#confessions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confessions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0067#la-seine-nous-s%C3%A9pare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Seine Nous Sépare")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0072#washington-square",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington Square")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#on-pain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Pain")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0075#icarus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Icarus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0076#icarus-ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Icarus II")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0077#vague-%C3%A0-l%C3%A2me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vague à l’Âme")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0078#ghosts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0080#fantasies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fantasies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0081#shards",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shards")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0083#wander",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wander")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0084#shadows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shadows")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0085#wounded-hearts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wounded Hearts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0086#the-melody-of-memories",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Melody of Memories")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ove",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("_OVE")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0087#silence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silence")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#blank-page-noun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blank Page: (Noun)")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0088#the-looking-glass",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Looking Glass")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0089#coffee-grains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coffee Grains")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0089#a-letter-to-my-grandmother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A letter to my grandmother")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0090#what-remains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Remains")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#on-hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Hope")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0092#the-accident",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Accident")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0093#first-impressions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Impressions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0095#waiting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0096#hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#on-beauty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Beauty")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0097#gramercy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gramercy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0098#sunset",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunset")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0099#the-ginkgo-leaf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ginkgo Leaf")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0100#la-lune",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Lune")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0101#concorde",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concorde")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0102#palais-galliera",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palais Galliera")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0105#the-dandelion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dandelion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0106#quai-branly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quai Branly")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0108#chamonix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chamonix")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0109#quai-des-tuileries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quai des Tuileries")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0110#pont-alexandre-iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pont Alexandre III")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0112#the-countdown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Countdown")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0113#vol-de-nuit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vol de Nuit")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0114#bond-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bond Street")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0115#somewhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Somewhere")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#on-growth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Growth")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0116#expectations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expectations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0118#gare-du-nord",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gare du Nord")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0119#revelations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0120#kaleidoscope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kaleidoscope")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0122#in-search-of-daffodils",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Search of Daffodils")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0126#the-cost-of-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cost of Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0128#enough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enough")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0130#new-york.-655-am",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York. 6:55 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0132#the-sphinx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sphinx")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0133#absence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Absence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0137#je-suis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Je Suis")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0138#remnants",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remnants")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0140#dame-de-fer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dame de Fer")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0